import { type AxiosError, HttpStatusCode } from "axios";

import { useAdminStore } from "@/stores";

export const errorResponse = async (error: AxiosError) => {
  if (error?.response?.status === HttpStatusCode.Unauthorized) {
    window.location.href = "/login?redirect=" + encodeURIComponent(window.location.pathname);

    useAdminStore.getState().clearAdmin();
  }

  return Promise.reject(error);
};
